export default "__VITE_ASSET__7r4d4at3__"